import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import type ErrorData from 'sharedreact/data/ErrorData';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import SettingsStore from 'sharedreact/stores/SettingsStore';

import LoggingConnection from 'workspaces/launcher/connections/LoggingConnection';
import LogEntry from 'workspaces/launcher/data/LogEntry';

const UPDATE_SERVER_LOG = 'UPDATE_SERVER_LOG';

function _sendToServer () {
  AppDispatcher.dispatch({
    actionType: UPDATE_SERVER_LOG,
    logLevel: 'trace'
  });
}

function _onError (error: ErrorData) {
  console.log(error);
}

const Content: {
  items: Immutable.List<LogEntry>
} = {
  items: Immutable.List()
};

class State extends Immutable.Record(Content) {
}

class LoggingStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
    setInterval(_sendToServer, 10000);
  }

  override getInitialState (): State {
    return new State();
  }

  override reduce (state: State, action: ActionType): State {
    const logLevel: string = SettingsStore.getSettings().logLevel;

    if (action.actionType === UPDATE_SERVER_LOG) {
      if (state.items.size > 0) {
        LoggingConnection.updateServerLog(state.items, () => {}, _onError);

        return state.set('items', Immutable.List());
      }
    } else {
      if (!action.actionType.includes('_UPDATE') && action.logLevel !== 'neverlog') {
        if (LogEntry.getLogLevelIndex(action.logLevel) >= LogEntry.getLogLevelIndex(logLevel)) {
          const logEntry = LogEntry.createFromAction(action);

          return state.set('items', state.items.push(logEntry));
        }
      }
    }

    return state;
  }
}

export default new LoggingStore();
